import { IIndirectTaxPortal } from '@commenda/api/indirect-tax/registrations';
import { Badge } from '@commenda/kakashi';
import { toTitleCasePreservingAcronyms } from '@commenda/utils';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import { RadioInput } from '../../../components';

interface IndirectTaxRegistrationPortalCardProps {
  portal: IIndirectTaxPortal;
  isSelected: boolean;
  hasExistingCredentials?: boolean;
  isCurrentlyUsed?: boolean;
  onSelect: (portalId: string) => void;
}

export const IndirectTaxRegistrationPortalCard: React.FC<
  IndirectTaxRegistrationPortalCardProps
> = ({ portal, isSelected, hasExistingCredentials = false, isCurrentlyUsed = false, onSelect }) => {
  return (
    <div
      className={`flex flex-col border rounded-lg cursor-pointer ${isSelected
          ? 'border-utility-brand-600 bg-utility-brand-50'
          : 'border-border-secondary'
        }`}
      onClick={() => onSelect(portal.portalId)}
    >
      <div className="flex items-center gap-3 p-4">
        <RadioInput
          id={portal.portalId}
          label=""
          checked={isSelected}
          onCheck={() => onSelect(portal.portalId)}
          _css="py-0"
        />
        <p className="txt-small-medium text-text-secondary">
          {toTitleCasePreservingAcronyms(portal.portalName)}
        </p>
        {isCurrentlyUsed && (
          <Badge variant="blue" size="sm">
            Currently used
          </Badge>
        )}
      </div>

      {isSelected && hasExistingCredentials && (
        <div className="mx-4 mb-4 p-3 bg-utility-brand-50 border border-utility-brand-200 rounded-lg flex items-start gap-2">
          <LockClosedIcon className="w-5 h-5 text-utility-brand-600 flex-shrink-0 mt-0.5" />
          <div className="flex flex-col">
            <p className="txt-small-medium text-text-primary">
              Credentials already on file
            </p>
            <p className="txt-small-regular text-text-secondary">
              Commenda has securely stored login credentials for this portal and
              will use them to manage filings.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
